import {normalizeURL} from '../urlHandling/urlNormalizer.ts';
import type {SeasonCode} from '../layers/layerTypes.ts';
import type {LanguageCode} from '../i18n.ts';

/**
 * Set metadata for canonical and alternate languages.
 * Set page language.
 * @param normalizedURL
 * @param detectedLang
 * @param languageCodes
 * @param season
 * @param doc
 */
export function setCanonicalAndLanguageRelatedMetadata(
  normalizedURL: string,
  detectedLang: LanguageCode,
  languageCodes: Readonly<LanguageCode[]>,
  season: SeasonCode,
  doc: Document,
) {
  const url = new URL(normalizedURL);
  const canonicalHref = `${url.origin}${url.pathname}`;
  const canonicalLink = doc.createElement('link');
  canonicalLink.setAttribute('rel', 'canonical');
  canonicalLink.setAttribute('href', canonicalHref);
  doc.head.appendChild(canonicalLink);
  const alternateLanguages = languageCodes.filter((c) => c !== detectedLang);
  alternateLanguages.forEach((lang) => {
    const url = canonicalHref.replace(`/${detectedLang}/`, `/${lang}/`);
    const {normalizedURL} = normalizeURL(url, lang, season, '');

    const link = doc.createElement('link');
    link.setAttribute('rel', 'alternate');
    link.setAttribute('href', normalizedURL);
    link.setAttribute('hreflang', lang);
    doc.head.appendChild(link);
  });
  doc.documentElement.lang = detectedLang;
}
